export interface IContactSubtabsProps {
    onTabChanged: (tab: ContactSubtabsEnum) => void;
    selectedTab: ContactSubtabsEnum;
}

export enum ContactSubtabsEnum {
    accounts = 'accounts',
    contactCommunications = 'contact communications'
}